import { render, staticRenderFns } from "./NoMoneyPopup.vue?vue&type=template&id=38968d20"
import script from "./NoMoneyPopup.vue?vue&type=script&lang=js"
export * from "./NoMoneyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports